import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 33"
    {...props}
  >
    <path
      fill="currentColor"
      d="M29 12.096a1 1 0 0 0-.038-.275L27.17 5.546a2.01 2.01 0 0 0-1.919-1.45H6.75a2.01 2.01 0 0 0-1.919 1.45L3.04 11.821a1 1 0 0 0-.039.275v2a5 5 0 0 0 2 4v8a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-8a5 5 0 0 0 2-4zm-22.25-6h18.5l1.427 5H5.327zm6.25 7h6v1a3 3 0 0 1-6 0zm-2 0v1a3 3 0 0 1-6 0v-1zm14 13H7v-7.1q.495.1 1 .1a5 5 0 0 0 4-2 5 5 0 0 0 8 0 5 5 0 0 0 5 1.9zm-1-9a3 3 0 0 1-3-3v-1h6v1a3 3 0 0 1-3 3"
    />
  </svg>
);
const SvgIconMarketplace = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconMarketplace);
export default Memo;
